export let AdornmentType;
(function (AdornmentType) {
  AdornmentType["Icon"] = "icon";
  AdornmentType["Affix"] = "affix";
})(AdornmentType || (AdornmentType = {}));
export let AdornmentSide;
(function (AdornmentSide) {
  AdornmentSide["Right"] = "right";
  AdornmentSide["Left"] = "left";
})(AdornmentSide || (AdornmentSide = {}));
export let InputMode;
(function (InputMode) {
  InputMode["Outlined"] = "outlined";
  InputMode["Flat"] = "flat";
})(InputMode || (InputMode = {}));
//# sourceMappingURL=enums.js.map